import { Box, BoxProps, Image, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
const done = require('../../../assets/images/done.png')

interface CheckListProps {
  data: any
  isMobile?: boolean
  isTab?: boolean
}

const CheckList: FC<CheckListProps> = ({ data, isMobile, isTab }: CheckListProps) => {
  return (
    <Box {...styles.container}>
      {data?.map((item: any) => {
        return (
          <Box display="flex" flexDirection="row" alignItems="center" marginY={8}>
            <Image source={item.image ?? done} resizeMode="contain" height={24} width={24} />
            <Spacer size="LARGE" direction="horizontal" />
            <Text
              fontFamily="jiotype-medium"
              fontSize={isMobile || isTab ? 'FONT_SIZE_MEDIUM' : 'FONT_SIZE_LARGE'}
              lineHeight={isMobile || isTab ? 21 : 24}
              color="BRAND_COLOR_GRAY_1">
              {item.text}
            </Text>
          </Box>
        )
      })}
    </Box>
  )
}

const styles = {
  container: {
    display: 'flex',
    position: 'relative',
  } as BoxProps,
}

export default CheckList
